import { formatDateFromDB } from '../../../../utils/FormatDate';
import { currencyFormatDE } from '../../../../utils/currencyFormat';
import MuiGridOptions from './MuiGridOptions';
import OStatus from '../OStatus/OStatus';
import { colors } from '../../../../shared/colors';
import { icons } from '../../../../shared/icons';

// da li praviti hook use columns
export const columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'firstName',
    headerName: 'First name',
    width: 150,
  },
  {
    field: 'lastName',
    headerName: 'Last name',
    width: 150,
  },
  {
    field: 'age',
    headerName: 'Age',
    type: 'number',
    width: 110,
  },
  {
    field: 'date',
    headerName: 'Date',
    type: 'date',
    width: 150,
    valueFormatter: ({ value }) => formatDateFromDB(value),
  },
  {
    field: 'decimal',
    headerName: 'Decimal',
    type: 'number',
    width: 110,
    valueFormatter: ({ value }) => currencyFormatDE(value),
  },
  {
    field: 'fullName',
    headerName: 'Full name',
    description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 160,
    valueGetter: (params) =>
      `${params.row.firstName || ''} ${params.row.lastName || ''}`,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
    renderCell: ({ value }) => (
      <OStatus
        icon={
          value === 'Završen'
            ? icons.CHECK_ICON
            : value === 'U toku'
            ? icons.IN_PROGRESS_ICON
            : value === 'Odbijen'
            ? icons.CLOSE_ICON
            : null
        }
        text={value}
        backgroundColor={
          value === 'Završen'
            ? colors.SUCCESS
            : value === 'U toku'
            ? colors.WARNING
            : value === 'Odbijen'
            ? colors.ERROR
            : null
        }
        textColor={
          value === 'Završen'
            ? colors.SUCCESS_TEXT
            : value === 'U toku'
            ? colors.WARNING_TEXT
            : value === 'Odbijen'
            ? colors.ERROR_TEXT
            : null
        }
      />
    ),
  },
  {
    field: 'opcije',
    headerName: '',
    width: 110,
    sortable: false,
    filterable: false,
    renderCell: () => (
      <MuiGridOptions>
        <button className="header-options">{icons.MENU_ICON}</button>
      </MuiGridOptions>
    ),
  },
];

export const rows = [
  {
    id: 1,
    lastName: 'Snow',
    firstName: 'Jon',
    age: 35,
    date: new Date(),
    decimal: 10500,
    telefon: 12121,
    status: 'Završen',
  },
  {
    id: 2,
    lastName: 'Lannister',
    firstName:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book',
    age: 42,
    date: new Date(),
    decimal: 3234,
    telefon: 12121,
    status: 'Završen',
  },
  {
    id: 3,
    lastName: 'Lannister',
    firstName: 'Jaime',
    age: 45,
    date: new Date(),
    decimal: 9800,
    telefon: 12121,
    status: 'Odbijen',
  },
  {
    id: 4,
    lastName: 'Stark',
    firstName: 'Arya',
    age: 16,
    date: new Date(),
    decimal: 12,
    telefon: 12121,
    status: 'Završen',
  },
  {
    id: 5,
    lastName: 'Targaryen',
    firstName: 'Daenerys',
    age: null,
    date: new Date(),
    decimal: 2311,
    telefon: 12121,
    status: 'U toku',
  },
  {
    id: 6,
    lastName: 'Melisandre',
    firstName: null,
    age: 150,
    date: new Date(),
    decimal: null,
    telefon: 12121,
    status: 'Završen',
  },
  {
    id: 7,
    lastName: 'Clifford',
    firstName: 'Ferrara',
    age: 44,
    date: null,
    decimal: null,
    telefon: 12121,
    status: 'Završen',
  },
  {
    id: 8,
    lastName: 'Frances',
    firstName: 'Rossini',
    age: 36,
    date: new Date(),
    decimal: 10500,
    telefon: 12121,
    status: 'Završen',
  },
  {
    id: 9,
    lastName: 'Roxie',
    firstName: 'Harvey',
    age: 65,
    date: new Date(),
    decimal: 10500,
    telefon: 12121,
    status: 'Završen',
  },
];
